/**
 * User-facing vocabulary, in one place.
 *
 * The app started out calling everything a "tournament", which reads wrong for four
 * friends playing a single weekend round. Every visible noun now comes from here, so
 * the whole app's language changes by editing this file — swap `event` for "outing",
 * "trip", "match", or back to "tournament" and the UI follows.
 *
 * Internal names (the `/api/tournament/...` routes, the TournamentDO class, the
 * `adminToken` field) deliberately keep the old wording: renaming them would be a
 * migration with no user-visible benefit.
 */
export const APP_NAME = "Divot Golf";

export const TERMS = {
  /** Singular, lowercase — mid-sentence. */
  event: "game",
  /** Singular, capitalised — headings and buttons. */
  Event: "Game",
  /** Plural, lowercase. */
  events: "games",
  /** Plural, capitalised. */
  Events: "Games",
  /** The person who set the game up. US spelling — swap the z for an s for a UK build. */
  organizer: "organizer",
  /** Singular, capitalised — headings and buttons. */
  Organizer: "Organizer",
};

/** Capitalises only when it starts a sentence, so copy stays natural either way. */
export function anEvent(): string {
  return `a ${TERMS.event}`;
}
